import '../../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import ArticulosModal from '../../../../articulos/articulosModal/articulosModal';

Modal.setAppElement('#root');

const FiltersGrid = ({ 
  setSearchIDFilter,
  setSearchDescFilter,}) => {
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const renderModals = () => (
    <>
      <ArticulosModal
        handleChange={(id) => setSearchIDFilter(id)}
        handleDescChange={(desc) => setSearchDescFilter(desc)}
      />
    </>
  );

  return (
    <div className="filterContainer">
      {isSmallScreen ? (
        <>
          <button className="filterButton" onClick={handleOpenModal}>
            Filtros De Búsqueda
          </button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Seleccionar Filtros"
            className="modalScreen"
            overlayClassName="overlayScreen"
          >
            <h2>Filtros de Búsqueda</h2>
            <div className="modalContent">
              {renderModals()}
            </div>
            <button className="modalCloseButton" onClick={handleCloseModal}>
              ❌
            </button>
          </Modal>
        </>
      ) : (
        <div className="searchContainer">
          {renderModals()}
        </div>
      )}
    </div>
  );
};

export default FiltersGrid;
